import * as Scrivito from "scrivito";
import { isLiv } from "^/utils/isLiv";
import LinkWrapper from "./LinkWrapper";

Scrivito.provideComponent("ImageWidget", ({ widget }) => {
  const classNames = ["image-widget"];
  const bgColor = isLiv(Scrivito.currentPage()) ? "bg-teal" : "bg-blue";
  const blendMode = widget.get("blendMode");

  if (["center", "right"].includes(widget.get("alignment"))) {
    classNames.push(`text-${widget.get("alignment")}`);
  }
  if (blendMode) {
    classNames.push("--blend-background");
  }

  const description = descriptionText(widget);
  const width =
    widget.get("width") || widget.get("image")?.metadata().get("width");
  const height =
    widget.get("height") || widget.get("image")?.metadata().get("height");

  return (
    <Scrivito.WidgetTag
      className={classNames.join(" ")}
      height={widget.get("height")}
      width={widget.get("width")}
    >
      <LinkWrapper link={widget.get("link")} className="d-block">
        <Scrivito.ImageTag
          content={widget}
          attribute="image"
          className="img-fluid"
          alt={alternativeText(widget)}
          loading="lazy"
          width={width}
          height={height}
          style={{ aspectRatio: `${width} / ${height}` }}
        />
        {description && (
          <div
            className={`image-description p-2 ${bgColor}`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </LinkWrapper>
    </Scrivito.WidgetTag>
  );
});

function alternativeText(widget) {
  const widgetAlternativeText = widget.get("alternativeText");
  if (widgetAlternativeText) {
    return widgetAlternativeText;
  }

  const image = widget.get("image");
  if (image) {
    return image.get("alternativeText");
  }

  return "";
}

function descriptionText(widget) {
  const widgetdescription = widget.get("description");
  if (widgetdescription) {
    return widgetdescription;
  }

  const image = widget.get("image");
  if (image) {
    return image.get("description");
  }

  return "";
}
